export enum LoginType {
  JP = 'JP',
}